import { createSvgIcon } from '../../createSvgIcon';

export const TimeIcon = createSvgIcon(
  <path
    d="M11.4167 10.5278L8.75 8.75V4.30556M0.75 8.75C0.75 9.80058 0.956926 10.8409 1.35896 11.8115C1.761 12.7821 2.35028 13.664 3.09315 14.4069C3.83601 15.1497 4.71793 15.739 5.68853 16.141C6.65914 16.5431 7.69943 16.75 8.75 16.75C9.80058 16.75 10.8409 16.5431 11.8115 16.141C12.7821 15.739 13.664 15.1497 14.4069 14.4069C15.1497 13.664 15.739 12.7821 16.141 11.8115C16.5431 10.8409 16.75 9.80058 16.75 8.75C16.75 7.69943 16.5431 6.65914 16.141 5.68853C15.739 4.71793 15.1497 3.83601 14.4069 3.09315C13.664 2.35028 12.7821 1.761 11.8115 1.35896C10.8409 0.956926 9.80058 0.75 8.75 0.75C7.69943 0.75 6.65914 0.956926 5.68853 1.35896C4.71793 1.761 3.83601 2.35028 3.09315 3.09315C2.35028 3.83601 1.761 4.71793 1.35896 5.68853C0.956926 6.65914 0.75 7.69943 0.75 8.75Z"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  { displayName: 'TimeIcon', viewBox: '0 0 18 18' }
);
